import styled from 'styled-components';
import { CALLER_COLORS as C } from '../tokens';

// Grid of selectable service cards (image + name) for the Add Services modal.
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
  padding: 18px 22px 22px;
  max-height: 60vh;
  overflow-y: auto;
`;

export const ServiceCard = styled.button<{ $selected?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 9px;
  padding: 14px 10px;
  background: ${(p) => (p.$selected ? C.orangeSoftBg : '#fff')};
  border: 1.5px solid ${(p) => (p.$selected ? C.accentOrange : C.border)};
  border-radius: 12px;
  cursor: pointer;
  transition: border-color 0.12s, background 0.12s;
  &:hover {
    border-color: ${C.accentOrange};
  }
`;

export const CardImg = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 999px;
  background: ${C.avatarBg};
  border: 1px solid rgba(0, 0, 0, 0.06);
  overflow: hidden;
  flex-shrink: 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const CardName = styled.span<{ $selected?: boolean }>`
  color: ${(p) => (p.$selected ? C.accentOrange : C.navy)};
  font-size: 14px;
  font-weight: 600;
  text-align: center;
`;
